"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.extractVirtualSheetConfiguration = exports.validateVirtualSheetConfiguration = void 0;
const edit_1 = __importDefault(require("@sheet/edit"));
const common_1 = require("@finley-technologies/common");
const validateVirtualSheetConfiguration = ({ virtualSheet, fields, }) => {
    const errors = [];
    // check virtual sheet has headers
    if (virtualSheet.length === 0) {
        errors.push({
            type: 'metadataValidation',
            message: 'virtualSheet must have at least one row configured.',
        });
        return errors;
    }
    const fieldNameSet = new Set(fields.map((fieldConfigs) => fieldConfigs.field));
    // check every header is defined in fields
    const headers = virtualSheet[0];
    const headerNameSet = new Set();
    headers.forEach((header) => {
        if (typeof header !== 'string') {
            errors.push({
                type: 'metadataValidation',
                message: 'virtualSheet headers must be of type string.',
            });
        }
        else {
            if (!fieldNameSet.has(header)) {
                errors.push({
                    type: 'metadataValidation',
                    message: `virtualSheet [header:${header}] must defined in fields.`,
                });
            }
            if (headerNameSet.has(header)) {
                errors.push({
                    type: 'metadataValidation',
                    message: `virtualSheet [header:${header}] is duplicated.`,
                });
            }
            headerNameSet.add(header);
        }
    });
    // check very field is defined headers
    Array.from(fieldNameSet).forEach((fieldName) => {
        if (!headerNameSet.has(fieldName)) {
            errors.push({
                type: 'metadataValidation',
                message: `field [fieldName:${fieldName}] must defined in headers row 1.`,
            });
        }
    });
    return errors;
};
exports.validateVirtualSheetConfiguration = validateVirtualSheetConfiguration;
const extractVirtualSheetConfiguration = ({ buffer, }) => {
    const workbook = edit_1.default.read(buffer, {
        type: 'buffer',
        cellFormula: true,
        cellDates: true,
    });
    const sheetName = 'finleyVirtualSheet';
    const worksheet = workbook.Sheets[sheetName];
    (0, common_1.finleyAssert)(worksheet, '[worksheet:finleyVirtualSheet] must exist to extract configuration.');
    const sheetRange = worksheet['!ref'];
    (0, common_1.finleyAssert)(sheetRange, '[worksheet:finleyVirtualSheet] range must exist to extract configuration.');
    const range = edit_1.default.utils.decode_range(sheetRange);
    // Prepare 2D array to hold results
    const sheetData = [];
    // eslint-disable-next-line no-restricted-syntax
    for (let row = range.s.r; row <= range.e.r; row += 1) {
        const rowData = [];
        // eslint-disable-next-line no-restricted-syntax
        for (let col = range.s.c; col <= range.e.c; col += 1) {
            const cellAddress = edit_1.default.utils.encode_cell({ r: row, c: col });
            const cell = worksheet[cellAddress];
            if (cell) {
                // Prefer formula if present, else raw value
                rowData.push(cell.f ? `=${cell.f}` : cell.v ?? '');
            }
            else {
                rowData.push('');
            }
        }
        sheetData.push(rowData);
    }
    return sheetData;
};
exports.extractVirtualSheetConfiguration = extractVirtualSheetConfiguration;
//# sourceMappingURL=virtualSheetConfiguration.js.map